<div class="modal" *ngIf="!showConfirmation">
  <div class="modal-header">
    <p class="title">{{ 'New campaign' | translate }}</p>
    <div class="buttons">
      <app-button
        class="cancel-btn"
        [disabled]="loading"
        (onClick)="cancel()"
        [label]="'Cancel' | translate"
        [secondary]="true"
      ></app-button>
      <button
        type="button"
        class="accept-btn"
        [class.disabled]="disabled || loading"
        [class.loading]="loading"
        [disabled]="disabled || loading"
        (click)="save()"
      >
        <span class="label">{{ 'Save' | translate }}</span>
        <span *ngIf="loading" class="btn-spinner"></span>
      </button>
    </div>
  </div>
  <form class="modal-content">
    <div class="block">
      <label for="name">{{ 'Name' | translate }}</label>
      <input id="name" name="name" type="text" [(ngModel)]="campaignName" />
    </div>
    <div class="block flex">
      <app-checkbox
        (onChange)="onChangeCampaignType($event, 'deliveries')"
        [checked]="campaignType === 'deliveries'"
        type="radio"
        value="deliveries"
        [label]="'By deliveries' | translate"
      >
      </app-checkbox>
      <app-checkbox
        (onChange)="onChangeCampaignType($event, 'days')"
        [checked]="campaignType === 'days'"
        type="radio"
        value="days"
        [label]="'By days' | translate"
      >
      </app-checkbox>
    </div>
    <div class="block flex" *ngIf="campaignType === 'deliveries'">
      <div class="block shrink">
        <label>{{ 'Size' | translate }}</label>
        <app-selector
          [autoClose]="true"
          [options]="sizeOptions"
          [selected]="selectedSize"
          (onSelectOption)="onSelectTarget($event)"
        >
        </app-selector>
      </div>
      <div class="block grow">
        <label for="start_delivery">{{ 'Start Delivery' | translate }}</label>
        <app-selector
          *ngIf="deliveries.length"
          [autoClose]="true"
          [options]="deliveries"
          [selected]="startDelivery || deliveries[0]"
          (onSelectOption)="onSelectStartDelivery($event)"
        >
        </app-selector>
      </div>
    </div>
    <div class="block flex" *ngIf="campaignType === 'days'">
      <div class="block grow">
        <label for="start-date-input">{{ 'Start Date' | translate }}</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            id="start-date-input"
            [matDatepicker]="startPicker"
            [min]="minDeliveryDate"
            [max]="maxDeliveryDate"
            [(ngModel)]="startDate"
            name="start_date"
          />
          <button
            *ngIf="startDate"
            matSuffix
            (click)="startDate = null"
            class="clear-btn"
          >
            <img src="/assets/img/icons/accent/close.svg" alt="clear" />
          </button>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="startPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="block grow">
        <label for="end-date-input">{{ 'End Date' | translate }}</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            id="end-date-input"
            [matDatepicker]="endPicker"
            [min]="minDeliveryDate"
            [max]="maxDeliveryDate"
            [(ngModel)]="endDate"
            name="end_date"
          />
          <button
            *ngIf="endDate"
            matSuffix
            (click)="endDate = null"
            class="clear-btn"
          >
            <img src="/assets/img/icons/accent/close.svg" alt="clear" />
          </button>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="endPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<div class="modal confirm" *ngIf="showConfirmation">
  <div class="modal-header">
    <p class="title">{{ 'Creation successful' | translate }}</p>
  </div>
  <div class="modal-content">
    <p>
      {{
        'The campaign was created successfully, to view it you need to go to campaigns section and select it'
          | translate
      }}
    </p>
    <app-button
      class="accept-btn"
      (onClick)="confirm()"
      [label]="'Close' | translate"
    ></app-button>
  </div>
</div>
